'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleSmallest = exports.TitleSmaller = exports.TitleSmall = exports.TitleJumbo = exports.TitleDefault = exports.TitleBase = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin: ', ';\n  padding: ', ';\n'], ['\n  margin: ', ';\n  padding: ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  font-size: ', ';\n'], ['\n  font-size: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _text = require('@hixme-ui/text');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TitleBase = exports.TitleBase = _text.TextBase.withComponent('h1').extend(_templateObject, function (props) {
  return props.margin || '0px';
}, function (props) {
  return props.padding || '0px';
});

var TitleDefault = exports.TitleDefault = TitleBase.extend(_templateObject2, function (props) {
  return props.fontSize || '34px';
});

var TitleJumbo = exports.TitleJumbo = TitleBase.extend(_templateObject2, function (props) {
  return props.fontSize || '38px';
});

var TitleSmall = exports.TitleSmall = TitleBase.withComponent('h2').extend(_templateObject2, function (props) {
  return props.fontSize || '28px';
});

var TitleSmaller = exports.TitleSmaller = TitleBase.withComponent('h3').extend(_templateObject2, function (props) {
  return props.fontSize || '20px';
});
var TitleSmallest = exports.TitleSmallest = TitleBase.withComponent('h4').extend(_templateObject2, function (props) {
  return props.fontSize || '18px';
});

var Title = function Title(_ref) {
  var jumbo = _ref.jumbo,
      small = _ref.small,
      smaller = _ref.smaller,
      smallest = _ref.smallest,
      children = _ref.children,
      props = (0, _objectWithoutProperties3.default)(_ref, ['jumbo', 'small', 'smaller', 'smallest', 'children']);

  var Tag = TitleDefault;
  if (jumbo) {
    Tag = TitleJumbo;
  } else if (small) {
    Tag = TitleSmall;
  } else if (smaller) {
    Tag = TitleSmaller;
  } else if (smallest) {
    Tag = TitleSmallest;
  }

  return _react2.default.createElement(
    Tag,
    props,
    children
  );
};

Title.displayName = 'hui:Title';
Title.huiName = 'Title';

Title.propTypes = {
  jumbo: _propTypes2.default.bool,
  small: _propTypes2.default.bool,
  smaller: _propTypes2.default.bool,
  smallest: _propTypes2.default.bool,
  children: _propTypes2.default.any
};
Title.defaultProps = {
  jumbo: false,
  small: false,
  smaller: false,
  smallest: false,
  children: null
};

exports.default = Title;
//# sourceMappingURL=Title.js.map


//////////////////
// WEBPACK FOOTER
// ../title/lib/Title.js
// module id = 574
// module chunks = 0